// DS3.4
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import TextInput from '../TextInput';
import SearchIcon from '../../../Icons/24x24/Search';
import CloseIcon from '../../../Icons/24x24/Close';
import PlainButtonOrLink from '../../../Buttons/PlainButtonOrLink';
const SearchInput = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { onClearClick, value, disabled } = _param, rest = _object_without_properties(_param, [
        "onClearClick",
        "value",
        "disabled"
    ]);
    const prefix = /*#__PURE__*/ React.createElement(SearchIcon, {
        disableDefaultColors: true
    });
    const postfix = value ? /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        onClick: onClearClick,
        type: "button"
    }, /*#__PURE__*/ React.createElement(CloseIcon, null)) : null;
    return /*#__PURE__*/ React.createElement(TextInput, _object_spread({
        ref: ref,
        prefix: prefix,
        postfix: postfix,
        value: value,
        disabled: disabled
    }, rest));
});
export default SearchInput;

//# sourceMappingURL=SearchInput.js.map